import './overview.scss'
import './Header.scss'
import React, { useEffect, useState, useRef } from 'react';
import { overviewService } from 'services/overviewService';

const ManHinhCho = () => {
    const loadUrl = async () => {
        const url = new URL(window.location.href);
        if (url.href.includes("xac-nhan-thanh-toan-mb")) {
            const params = new URLSearchParams(url.search);

            const allParamsObject = {};

            for (const [key, value] of params) {
                allParamsObject[key] = value; // Thêm vào đối tượng
            }

            const jsonString = JSON.stringify(allParamsObject);
            overviewService.loadUrl(jsonString);
        }
    }
    useEffect(() => {
        loadUrl();
    }, []);
    return (
        <>
        </>
    )
}


export default ManHinhCho;